const locales = {
    en: 'English',
    zh: '中国人',
    ja: '日本語',
    ko: '한국어'
};

const common = {
    english: 'English',
    chinese: '中国人',
    japanese: '日本語',
    korean: '한국어',
};

const messages = {
    en: {
        ...common,
        rooms_to_explore: 'Rooms to explore',
        loading_message: 'Loading... just a moment please',
    },
    ja: {
        ...common,
        rooms_to_explore: '探索する部屋',
        loading_message: '読み込んでいます...ちょっと待ってください',
    },
    zh: {
        ...common,
        rooms_to_explore: '探索房间',
        loading_message: '加载中...请稍等',
    },
    ko: {
        ...common,
        rooms_to_explore: '待探索的房间',
        loading_message: '로딩중... 잠시만요',
    }
}

export {locales,messages};